import React from 'react';
import { Box, Typography, Paper, useTheme } from '@mui/material';
import { motion } from 'framer-motion';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

const BusinessHours = () => {
  const theme = useTheme();

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <Paper
        elevation={0}
        sx={{
          p: 3,
          borderRadius: 2,
          backgroundColor: theme.palette.mode === 'dark' 
            ? 'rgba(255, 255, 255, 0.05)' 
            : 'rgba(0, 0, 0, 0.02)',
          border: `1px solid ${
            theme.palette.mode === 'dark' 
              ? 'rgba(255, 255, 255, 0.1)' 
              : 'rgba(0, 0, 0, 0.1)'
          }`,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <AccessTimeIcon color="primary" sx={{ mr: 1 }} />
          <Typography variant="h6" component="h3" sx={{ color: 'white', fontWeight: 'bold' }}>
            Business Hours
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography variant="body1" color="grey.100" sx={{ fontWeight: 'medium' }}>
              Sunday
            </Typography>
            <Typography variant="body1" sx={{ color: 'error.light' }}>
              Closed
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography variant="body1" color="grey.100" sx={{ fontWeight: 'medium' }}>
              Monday - Friday
            </Typography>
            <Typography variant="body1" color="grey.100">
              9:00 AM - 6:00 PM CT
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography variant="body1" color="grey.100" sx={{ fontWeight: 'medium' }}>
              Saturday
            </Typography>
            <Typography variant="body1" sx={{ color: 'error.light' }}>
              Closed
            </Typography>
          </Box>
          <Typography 
            variant="caption" 
            color="grey.100" 
            sx={{ mt: 1, display: 'block' }}
          >
            All times are in Central Time (CT)
          </Typography>
        </Box>
      </Paper>
    </motion.div>
  );
};

export default BusinessHours;
